import { render, staticRenderFns } from "./NoGame.vue?vue&type=template&id=62d688c8&scoped=true&"
import script from "./NoGame.vue?vue&type=script&lang=js&"
export * from "./NoGame.vue?vue&type=script&lang=js&"
import style0 from "./NoGame.vue?vue&type=style&index=0&id=62d688c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d688c8",
  null
  
)

export default component.exports